import cn from 'classnames';

export enum FormStateType {
  ERROR = 'error',
  SUCCESS = 'success'
}
type Props = {
  message: string;
  type?: FormStateType;
};

const FormStateMessage = ({ message, type = FormStateType.ERROR }: Props) => {
  if (!message) return null;
  return (
    <p
      className={cn('txt_tf', {
        error_type1: type === FormStateType.ERROR,
        txt_success: type === FormStateType.SUCCESS
      })}
    >
      {message}
    </p>
  );
};

export default FormStateMessage;
